import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
  userdata: {},
  dataInscope: [],
  orgUnitData: [],
  isFetching: false,
  isSuccess: false,
  isUpdated: false,
  isError: false,
  userCount: 0,
  isDataInScopeSuccess: false,
  errorMessage: '',
  imagePath: '',
};

export const fetchAdminUser = createAsyncThunk(
  'user/viewUser/detailed/',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.get('/api/user/detailed/' + udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (response.status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);


export const getUsersInscope = createAsyncThunk(
  'user/detailed/scopeInProcess/',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      // const response = await axios.get('/api/user/detailed/scopeInProcess/' + udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let response = await axios({
        url: `/api/user/detailed/scopeInProcess/${udata}&limit=200`,
        method: 'get',
        //timeout: 8000,
        headers: {
          //'Content-Type': 'application/json',
          "Authorization": `Bearer ${tokenStr}`
        }
      })


      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (response.status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);


export const viewAdminUserSlice = createSlice({
  name: 'viewuser',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateViewUser: (state, { payload }) => {
      state.userdata = {};
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = false;
      state.isUpdated = false;
    },
    isSuccess: (state, { payload }) => {
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = false;
      state.isUpdated = false;
    },
    clearDataInScope: (state, { payload }) => {
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.dataInscope = [];
      state.isDataInScopeSuccess = false;
    },
    setOrgUnitNames: (state, { payload }) => {
      state.orgUnitData = payload.data;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
    [fetchAdminUser.fulfilled]: (state, { payload }) => {

      state.userdata = payload.data;
      // state.response = payload;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [fetchAdminUser.pending]: (state) => {
      state.isFetching = true;
    },
    [fetchAdminUser.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },

    [getUsersInscope.fulfilled]: (state, { payload }) => {

      state.dataInscope = payload.data.data;
      state.userCount = payload && payload.data && payload.data.metadata[0] && payload.data.metadata[0].total;
      state.imagePath = payload.data.imagePath;
      state.isFetching = false;
      state.isDataInScopeSuccess = true;
      return state;
    },
    [getUsersInscope.pending]: (state) => {
      state.isFetching = true;
    },
    [getUsersInscope.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },



  },
});


export const changeUserStatusInscope = (dataObj) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  const response = await axios.patch('/api/user/detailed/scopeInProcess/', dataObj, { headers: { "Authorization": `Bearer ${tokenStr}` } });

  let data = response.data;
  // console.log(data)
  //dispatch(setBranchStatus(data));
};


// For user organisation units.............

export const getOrgUnitForAdminAsyn = (bdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    // const response = await axios.get('/api/user/communication', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let response = await axios({
      url: `/api/user/communication?username=${bdata}`,
      method: 'get',
      // data: bdata,
      //timeout: 8000,
      headers: {
        //'Content-Type': 'application/json',
        "Authorization": `Bearer ${tokenStr}`
      }
    })

    let data = response.data;
    dispatch(setOrgUnitNames(data));
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateOrgUnitForAdminAsyn = (bdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.patch('/api/user/communication', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    return data;
  } catch (error) {
    return error.response.data;
  }
};

// update user permissions ...

export const updateUsersPermissionsAsyn = (bdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.patch('/api/user/permission', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    return data;
  } catch (error) {
    return error.response.data;
  }
};



export const { setOrgUnitNames, clearStateViewUser, clearDataInScope } = viewAdminUserSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateViewUser());
  }
}

export function clearStateDataInScope() {

  return async (dispatch) => {
    dispatch(clearDataInScope());
  }
}

export const viewAdminUserSelector = (state) => state.viewuser;

export default viewAdminUserSlice.reducer;
